export const notificationGreenClass =
  "mt-5 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-800 text-center";
export const notificationYellowClass =
  "mt-5 rounded-xl border border-yellow-200 bg-yellow-50 px-4 py-3 text-sm text-yellow-800 text-center";
export const notificationRedClass =
  "mt-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 text-center";
export const notificationGrayClass =
  "mt-5 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 text-center";
